export default __webpack_public_path__ + "static/FancyMediaContentFiftTeen-f0c58367ea97958d65e9f21fb8c8a557.webp";